<template>
  <div>
    <!-- Modal backdrop -->
    <transition
      enter-class="opacity-0"
      enter-active-class="transition ease-out duration-200"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition ease-out duration-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="modalOpen"
        class="fixed inset-0 bg-black/60 backdrop-blur-sm z-[200] transition-opacity"
        aria-hidden="true"
        @click.stop="$emit('close-modal')"
      />
    </transition>
    <!-- Modal dialog -->
    <transition
      enter-class="opacity-0 translate-y-4"
      enter-active-class="transition ease-in-out duration-200"
      enter-to-class="opacity-100 translate-y-0"
      leave-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in-out duration-200"
      leave-to-class="opacity-0 translate-y-4"
    >
      <div
        v-show="modalOpen"
        :id="id"
        class="fixed inset-0 z-[200] overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6 pointer-events-none"
        role="dialog"
        aria-modal="true"
      >
        <div
          ref="modalContent"
          class="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-auto w-full max-h-full pointer-events-auto"
          :class="panelWidthClass"
          @click.stop
        >
          <!-- Modal header -->
          <div class="px-5 py-3 border-b border-gray-200 dark:border-gray-700/60">
            <div class="flex justify-between items-start gap-3">
              <div class="min-w-0 flex-1 pr-2">
                <div class="font-semibold text-gray-800 dark:text-gray-100">
                  {{ title }}
                </div>
                <p
                  v-if="subtitle"
                  class="text-sm text-gray-500 dark:text-gray-400 mt-1 leading-snug"
                >
                  {{ subtitle }}
                </p>
              </div>
              <button
                type="button"
                class="shrink-0 mt-3 mb-2 mr-1 text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                @click.stop="$emit('close-modal')"
              >
                <span class="sr-only">Close</span>
                <svg class="fill-current" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"
                  />
                </svg>
              </button>
            </div>
          </div>
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ModalBasicTailwind',
  props: {
    id: {
      type: String,
      default: ''
    },
    modalOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    /** max-w-lg (default) | max-w-xl | max-w-2xl | max-w-3xl */
    size: {
      type: String,
      default: 'lg',
      validator: (v) => ['lg', 'xl', '2xl', '3xl'].includes(v)
    }
  },
  computed: {
    panelWidthClass() {
      const map = {
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl'
      }
      return map[this.size] || map.lg
    }
  },
  methods: {
    keyHandler(e) {
      if (!this.modalOpen || e.keyCode !== 27) return
      this.$emit('close-modal')
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keyHandler)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyHandler)
  }
}
</script>
